/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMouse = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c3.308 0 6 2.691 6 6v7c0 1.654 1.346 3 3 3h1v2h-1c-2.757 0-5-2.243-5-5V8c0-2.206-1.794-4-4-4S8 5.794 8 8v.1a5.01 5.01 0 0 1 4 4.9v4c0 2.757-2.243 5-5 5s-5-2.243-5-5v-4a5.009 5.009 0 0 1 4-4.9V8c0-3.309 2.692-6 6-6zm-5 8c-1.654 0-3 1.346-3 3v4c0 1.654 1.346 3 3 3s3-1.346 3-3v-4c0-1.654-1.346-3-3-3zm1 2v2H6v-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMouse as Mouse };
